import { Link } from 'react-router-dom';

interface ComicCardProps {
  id: number;
  title: string;
  category: string;
  cover: string;
  rating: number;
  status?: string;
  chapters?: number;
  hot?: boolean;
}

export default function ComicCard({ id, title, category, cover, rating, status, chapters, hot }: ComicCardProps) {
  return (
    <Link
      to={`/article/${id}`}
      className="group block flex-shrink-0 w-[200px] md:w-[220px] cursor-pointer"
      data-product-shop
    >
      <div className="relative overflow-hidden rounded-lg bg-background-100 aspect-[5/7] mb-3">
        <img
          src={cover}
          alt={`${title} - 韩国漫画封面`}
          title={`${title} - 好看的韩国漫画`}
          className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-400"
          loading="lazy"
        />
        {hot && (
          <span className="absolute top-2 right-2 px-2 py-0.5 bg-primary-500 text-background-50 text-xs font-semibold rounded whitespace-nowrap">
            HOT
          </span>
        )}
        {rating && (
          <div className="absolute bottom-2 left-2 px-2 py-0.5 bg-foreground-950/70 text-background-50 text-xs font-medium rounded whitespace-nowrap">
            <i className="ri-star-fill text-accent-500 mr-1"></i>
            {rating}
          </div>
        )}
      </div>
      <h3 className="text-sm font-semibold text-foreground-950 group-hover:text-primary-500 transition-colors line-clamp-1">
        {title}
      </h3>
      <div className="flex items-center justify-between mt-1">
        <span className="text-xs text-foreground-500">{category}</span>
        {chapters && (
          <span className="text-xs text-foreground-400">
            {status === '已完结' ? '完结' : `更新至${chapters}话`}
          </span>
        )}
      </div>
    </Link>
  );
}